import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout route: the page itself lives in es.podcasts.index.tsx. Without this wrapper the
// page component would shadow every nested child route.
export const Route = createFileRoute("/es/podcasts")({
  component: RouteLayout,
});

function RouteLayout() {
  return <Outlet />;
}
